import { render, staticRenderFns } from "./TicketLogCountImports.vue?vue&type=template&id=01bc8eed&"
import script from "./TicketLogCountImports.vue?vue&type=script&lang=js&"
export * from "./TicketLogCountImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports